export class TimeSheetRequest {
  public searchText: string = '';
  public tabName: string = '';
  public startDate!: number;
  public endDate!: number;
  public pageNumber: number = 1;
  public pageSize: number = 100;
}
